import type { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import SelectCountryCode from "~components/SelectCountryCode/SelectCountryCode.tsx";
import SelectPersonGender from "~components/SelectPersonGender";
import SelectPersonStatus from "~components/SelectPersonStatus";
import type { PersonStatuses } from "~enums/personStatuses";
import type { LabelValue } from "~types/labelValue.ts";

type Props = {
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  setNationality: Dispatch<SetStateAction<string | undefined>>;
  setGender: Dispatch<SetStateAction<string | undefined>>;
  setStatus: Dispatch<SetStateAction<PersonStatuses | undefined>>;
  disabled?: boolean;
  resetPagination: () => void;
};

export const AddPersonRolesModalFilters = ({
  setGender,
  setNationality,
  searchValue,
  setSearchValue,
  setStatus,
  disabled = false,
  resetPagination,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
  <>
    <SelectCountryCode
      placeholder={formatMessage({ id: "nationality" })}
      onChange={(nationality) => {
        resetPagination();
        setNationality((nationality as LabelValue | undefined)?.value);
      }}
      disabled={disabled}
    />
    <SelectPersonGender
      onChange={(gender) => {
        resetPagination();
        setGender((gender as LabelValue).value);
      }}
      disabled={disabled}
    />
    <SelectPersonStatus
      onChange={(status) => {
        resetPagination();
        setStatus((status as LabelValue).value as PersonStatuses | undefined);
      }}
      disabled={disabled}
    />
    <SearchFilter
      initial={searchValue}
      searchValue={searchValue}
      doSearch={(value) => {
        resetPagination();
        setSearchValue(value);
      }}
      placeholderIntlKey="search.two.letters"
    />
  </>
  );
};
